import { z } from "zod";

import { ClinicCallReason } from "@/shared/models/clinic-call-reason";

/** Server-resolved synthetic destination; null context means that role is not required by the route. */
export const telephoneEncounterRoutingReceiptSchema = z.object({
  recipientReference: z.string().startsWith("mock-"),
  recipientDisplayName: z.string().trim().min(1),
  providerEhrId: z.string().min(1).nullable(),
  locationEhrId: z.string().min(1).nullable(),
});

export type TelephoneEncounterRoutingReceipt = z.infer<typeof telephoneEncounterRoutingReceiptSchema>;

export const syntheticTelephoneEncounterSchema = z.object({
  id: z.string().uuid(),
  patientId: z.string().uuid(),
  caller: z.string(),
  reason: z.string(),
  message: z.string(),
  clinicCallReason: z.enum(ClinicCallReason),
  routingReceipt: telephoneEncounterRoutingReceiptSchema.nullable(),
  submissionId: z.string().uuid().nullable(),
});
